import {IWindowService} from "./window.service.interface";
import {WindowEventListenerRegistration} from "./window-event-listener-registration";
import {NullableString} from "../../types/nullable-types";



export class WindowService implements IWindowService {
    constructor() {
        this.subscribeTo = new WindowEventListenerRegistration(window);
    }
    getGlobalProperty<T=any>(name: string): T {
        return (window as any)[name] as T;
    }

    readonly subscribeTo: WindowEventListenerRegistration;

    setGlobalProperty(name: string, value: any): void {
        (window as any)[name] = value;
    }

    getOrigin(): string {
        return window.location.origin;
    }

    redirect(url: string): void {
        if(window.top) {
            window.top.location.href = url;
        } else {
            window.location.href = url;
        }

    }

    getUrlParam(paramName: string): NullableString {
        const url = new URL(window.location.href);

        let paramValue: NullableString = null;
        paramName = paramName.toLowerCase();

        url.searchParams.forEach((value, name) => {
            if(name.toLowerCase() === paramName) {
                paramValue = value;
            }
        });

        return paramValue;

    }

    postMessage(message: any): void {

        if(window.top) {
            window.top.postMessage(message, "*");
        } else {
            window.postMessage(message, "*");
        }
    }

    get searchParams(): URLSearchParams {
        return new URLSearchParams(window.location.search);
    }

    get origin(): string {
        return window.location.origin;
    }

    goBack(): void {
        window.history.back();
    }

}
